/**
 * Invisible CAPTCHA
 * @param elementId
 * @param actionName
 */
export function initGrecaptchaV3(elementId, actionName) {
    if (typeof window.grecaptcha !== 'undefined') {
        window.grecaptcha.ready(() => {
            window.grecaptcha
            .execute(
                $(`#${elementId}`).data('sitekey'),
                {
                    action: actionName,
                },
            )
            .then((token) => {
                $('#g-recaptcha-response').val(token);
            });
        });
    }
}
